import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import SectionBadge from "@/components/site/SectionBadge";
import { usePageMeta } from "@/lib/usePageMeta";

const GRID = "max-w-7xl mx-auto px-6 sm:px-8 md:px-12";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/insights", label: "Insights" },
  { to: "/contact", label: "Contact" },
  { to: "/capabilities/strategy-commercial-transformation", label: "Strategy & Commercial Transformation" },
  { to: "/capabilities/market-customer-intelligence", label: "Market & Customer Intelligence" },
  { to: "/capabilities/brand-marketing-communications", label: "Brand, Marketing & Communications" },
  { to: "/capabilities/digital-commerce", label: "Digital & Commerce" },
];

export default function NotFoundPage() {
  usePageMeta({
    title: "Page Not Found | BLEZZINGS",
    description:
      "The page you are looking for does not exist. Explore BLEZZINGS Growth Partners services, insights and contact options.",
    canonical: false,
    robots: "noindex, follow",
  });

  return (
    <div data-testid="not-found-page" className="relative">
      <Nav onBook={() => {}} />
      <section className="pt-32 md:pt-40 pb-16 md:pb-24 bg-[#fafafa]">
        <div className={`${GRID} max-w-4xl`}>
          <SectionBadge label="Error 404" />
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[1.05]">
            This page does not exist.
          </h1>
          <p className="mt-6 text-lg text-zinc-600 leading-relaxed max-w-2xl">
            The link may be outdated or the page may have moved. The essentials
            are one click away:
          </p>
          <ul className="mt-10 border-t border-black/10">
            {LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`notfound-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className="group flex items-center justify-between gap-6 py-5 border-b border-black/10"
                >
                  <span className="font-serif-display text-xl sm:text-2xl text-black transition-colors duration-300 group-hover:text-zinc-700">
                    {l.label}
                  </span>
                  <ArrowUpRight className="h-5 w-5 text-zinc-300 transition-all duration-300 group-hover:text-black group-hover:translate-x-1 group-hover:-translate-y-1" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>
      <Footer onJoin={() => {}} />
    </div>
  );
}
